import React, { PureComponent } from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import styled from 'styled-components';

import QandAList from '../../containers/q-and-a-list';
import TitledSection from '../titled-section';
import jaLocale from './ja.locale.js';

const PaddedContainer = styled.div`
  padding: 0 1em;

  @media (max-width: 767px) {
    padding-bottom: 1.5em;
  }
`;

/**
 * Help page
 */
class HelpPage extends PureComponent {
  constructor(props) {
    super(props);
    this.props.addTranslationForLanguage(jaLocale, 'ja');
  }

  render() {
    const { gameId } = this.props.pageContext;
    return (
      <TitledSection subtitleId="helpPage.subtitle" titleId="helpPage.title">
        <p>
          <Translate id={`helpPage.gameSpecificWarning`} />
        </p>
        <PaddedContainer>
          <QandAList paths={[`/helps/${gameId}`]} />
        </PaddedContainer>
      </TitledSection>
    );
  }
}

export default withLocalize(HelpPage);
